// extracted by mini-css-extract-plugin
module.exports = {"ck1jcsm":"ck1jcsm"};